// In-browser branded PDF via a print window (user saves as PDF).
const esc = (s) =>
  String(s == null ? "" : s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const analysisHtml = (text) =>
  esc(text)
    .replace(/(VERIFIED PROPERTY DATA|VERIFIED OFFICIAL DATA)/g,
      '<div class="tag verified">$1</div>')
    .replace(/(PROPERTYCHECK GUIDANCE)/g, '<div class="tag guidance">$1</div>')
    .split("\n").map((l) => (l.includes('class="tag"') || l.includes("class=\"tag") ? l : `<p>${l}</p>`))
    .join("");

export function downloadReportPdf(report, analysis, productLabel) {
  const r = report || {};
  const rows = [
    ["Property address", r.site_address || r.address],
    ["Folio", r.folio],
    ["Jurisdiction", r.jurisdiction || r.municipality],
    ["Owner", r.owner],
    ["Property use", r.property_use],
    ["Land use", r.land_use],
    ["Zoning", r.zoning_block?.zoning || r.zoning_block?.zone || r.zoning_block?.label],
    ["Permits on record", Array.isArray(r.permits) ? r.permits.length : null],
    ["Violations on record", Array.isArray(r.violations) ? r.violations.length : null],
    ["Inspections on record", Array.isArray(r.inspections) ? r.inspections.length : null],
  ].filter(([, v]) => v != null && v !== "");

  const sources = [...(r.official_sources || []), ...(r.sources || [])];
  const seen = new Set();
  const srcRows = sources.filter((s) => {
    const k = s.url || s.name || s.field;
    if (!k || seen.has(k)) return false;
    seen.add(k);
    return true;
  });

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Wise Property Search — ${esc(productLabel)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Georgia, 'Times New Roman', serif; color: #1a2332; margin: 0; padding: 48px; line-height: 1.55; }
    .brand { display:flex; align-items:center; gap:10px; border-bottom:3px solid #0f2e4c; padding-bottom:14px; margin-bottom:8px; }
    .brand .dot { width:30px; height:30px; border-radius:7px; background:#0f2e4c; color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; font-family:Arial; }
    .brand h1 { font-size:22px; margin:0; color:#0f2e4c; }
    .product { font-size:13px; color:#b8842a; font-weight:700; letter-spacing:.14em; text-transform:uppercase; margin:0 0 24px; font-family:Arial; }
    h2 { font-size:12px; letter-spacing:.16em; text-transform:uppercase; color:#0f2e4c; font-family:Arial; margin:26px 0 8px; border-bottom:1px solid #dbe2ea; padding-bottom:5px; }
    table { width:100%; border-collapse:collapse; font-size:13px; }
    td { padding:6px 4px; border-bottom:1px solid #eef1f5; vertical-align:top; }
    td.k { color:#5b6b7d; width:38%; font-family:Arial; font-size:12px; }
    td.v { font-weight:600; }
    .analysis p { font-size:13.5px; margin:6px 0; }
    .tag { font-family:Arial; font-size:10px; font-weight:700; letter-spacing:.14em; text-transform:uppercase; margin:14px 0 4px; }
    .tag.verified { color:#0a7d55; }
    .tag.guidance { color:#b8842a; }
    .src { font-size:11.5px; color:#33465a; margin:4px 0; }
    .src a { color:#0f2e4c; }
    .disclaimer { margin-top:26px; padding-top:12px; border-top:1px solid #dbe2ea; font-size:10.5px; color:#7a8798; font-family:Arial; }
    .meta { font-size:11px; color:#7a8798; font-family:Arial; }
    @media print { body { padding:24px; } }
  </style></head><body>
    <div class="brand"><div class="dot">PC</div><h1>Wise Property Search</h1></div>
    <p class="product">${esc(productLabel)}</p>

    <h2>Property</h2>
    <table>${rows.map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td class="v">${esc(v)}</td></tr>`).join("")}</table>
    ${r.retrieved_at ? `<p class="meta" style="margin-top:8px">Official records retrieved: ${esc(r.retrieved_at)}</p>` : ""}

    ${analysis ? `<h2>Analysis</h2><div class="analysis">${analysisHtml(analysis)}</div>` : ""}

    ${srcRows.length ? `<h2>Official sources</h2>${srcRows.map((s) =>
      `<p class="src">${esc(s.name || s.field || s.label || "Source")}${s.url ? ` — <a href="${esc(s.url)}">${esc(s.url)}</a>` : ""}</p>`).join("")}` : ""}

    <div class="disclaimer">Wise Property Search aggregates publicly available government records and provides general guidance only. It is not legal, engineering, or permitting advice and is not affiliated with any government agency. Always confirm requirements with the authority having jurisdiction before buying, building, or investing.</div>
    <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 350); };</script>
  </body></html>`;

  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
